// extracted by css-extract-rspack-plugin
export default {"MPFormContainer":"MPFormContainer-o5xGl6","mpFormContainer":"MPFormContainer-o5xGl6","FormSubmit":"FormSubmit-dI_DJG","formSubmit":"FormSubmit-dI_DJG"};